import Layout from "src/layout";
import styled, { css } from "styled-components";
import QcastStudio from "./QcastStudio";
import { useBoundStore } from "src/store";
import { useEffect, useRef, useState } from "react";
import { theme } from "src/styles/theme";


const RespondContainer = styled.div<{snapshot?: string}>`
    width: 100%;
    height: 100%;
    color: white;
    display: flex;
    flex-direction: column;
    border-top-left-radius: 20px;
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px); 
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.88), rgba(0, 0, 0, 0.88)), linear-gradient(0deg, rgba(19, 42, 131, 0.16), rgba(19, 42, 131, 0.16));
    
    
    background-image: ${({ snapshot }) => `url(${snapshot})`};
    background-size: cover;
    background-position: center;
    position: relative;

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.1); /* Transparent overlay */
        backdrop-filter: blur(15px); /* Glass effect */
        -webkit-backdrop-filter: blur(15px);
        border-radius: 10px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);

        @media(max-width: ${theme.breakpoints.mobile}px) {
            padding-bottom: 20px;
        }
    }
    @media(max-width: ${theme.breakpoints.mobile}px) {
        // height: 100svh;
        // padding-bottom: 20px;
        overflow: hidden;
    }
        
`;

const Respond = () => {

    const { globalSettings, questionIndex, questions, clearQcasts, responses, setQuestionIndex } = useBoundStore();
    const [currentVideoIndex, setCurrentVideoIndex] = useState<number>(0);
    const [videos, setVideos] = useState<any[]>([]);
    const [snapshot, setSnapshot] = useState<string | null>(null);
    
    
    const handleCancel = () => {
    };
    
    const handleRecord = () => {
    };
    
    const handleVideoNavigation = (index: number) => {
        // setCurrentVideoIndex(prev=>prev + index);
    }

    const handleSnapshot =(imageData: string) => {
        
        setSnapshot(imageData)
    }

    const processQuestions = () => {
        const videoQstn: any = questions?.listOfVideos instanceof Array && questions?.listOfVideos.map((video, index)=>{
          return {
            url: video,
            question: questions.title,
            comment: 0,
            maxDuration: questions.listOfResponsesLimits[index]
          }
        })
        setVideos(videoQstn);
    }

    

    useEffect(()=>{
        setCurrentVideoIndex(questionIndex);
    }, [questionIndex]);

    useEffect(()=>{
        const cleanStore=async()=>{
            await clearQcasts();
        }
        if(questions){
            clearQcasts();
            processQuestions();
        }
        cleanStore();
    }, [questions])

    return (
        <Layout>
            <RespondContainer snapshot={snapshot}>
                <QcastStudio 
                    setSnapshot={handleSnapshot}
                    questionNumber={currentVideoIndex + 1}
                    totalQuestions={questions?.numberOfVideo||0}
                    userAvatar={questions?.coverPhoto||""}
                    respondentAvatar="https://randomuser.me/api/portraits/women/23.jpg"
                    onCancel={handleCancel}
                    onRecord={handleRecord}
                    onnavigateVideo={handleVideoNavigation}
                    qcastVideos={videos}
                />
            </RespondContainer>
           
        </Layout>
    )
}

export default Respond;